export default __webpack_public_path__ + "static/media/metrics-resumes.3ab801d8.svg";